type RemoveBrandPrefixParameters = {
  brand: string;
  text: string;
};

export const removeBrandPrefix = ({
  brand,
  text,
}: RemoveBrandPrefixParameters): string => {
  if (!brand) {
    return text;
  }
  const regex = new RegExp(`^${brand}\\s*(\\w)`, "i");
  return text.replace(regex, (_, firstLetter) => firstLetter.toUpperCase());
};
